import { type PaginatedQueryParams } from 'queries/queries-utils'

import type { UseGetAttacksByIdQueryParams } from 'queries/attacks/types'

export const attacksQueryKeys = {
  getById: (query: UseGetAttacksByIdQueryParams) =>
    [`attacks/${query.attackId}`, query] as const,
  getActivePaged: (query: { teamId: string } & PaginatedQueryParams) =>
    ['attacks/active/paged', query] as const,
  getCompletedPaged: (params: { pageSize: number; teamId: string }) =>
    ['attacks/completed/paged', params] as const
}
